import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SchoolEntity } from "../../services/schools/school.types";

export type SchoolState = {
  schools: SchoolEntity[];
  loading: boolean;
};

const initialState: SchoolState = {
  schools: [],
  loading: false,
};

const school = createSlice({
  name: "school",
  initialState,
  reducers: {
    clearSchool: (state) => {
      state.schools = [];
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSchools: (state, action: PayloadAction<SchoolEntity[]>) => {
      state.schools = action.payload;
      state.loading = false;
    },
    addSchool: (state, action: PayloadAction<SchoolEntity>) => {
      state.schools.unshift(action.payload);
    },
    updateSchool: (
      state,
      action: PayloadAction<{ id: number; data: SchoolEntity }>
    ) => {
      const index = state.schools.findIndex(
        (school) => school.id === action.payload.id
      );
      if (index !== -1) {
        state.schools[index] = action.payload.data;
      }
    },
    deleteSchool: (state, action: PayloadAction<number>) => {
      state.schools = state.schools.filter(
        (school) => school.id !== action.payload
      );
    },
  },
});

export default school;
export const {
  clearSchool,
  setSchools,
  setLoading,
  addSchool,
  updateSchool,
  deleteSchool,
} = school.actions;
